import React, { useContext } from 'react'
// Icons
import { ReactComponent as ApplyNowIcon } from './icons/apply-now.svg'
import { AppConfigContext } from '../../../../context/AppConfig'
import { captureEvent } from '../../../../analytics'
import { analyticsEvents } from '../../../../analytics/events'
import { useStore } from '../../../../store'

const allowedLines = [
  {
    id: 3001534,
    link: 'https://www.evoqeastcobb.com/apartments/ga/marietta/apply#k=41434',
  },
  {
    id: 3001535,
    link: 'https://www.evoqeastcobb.com/apartments/ga/marietta/apply#k=41434',
  },
  {
    id: 3002261,
    link: 'https://www.thenovusapartments.com/apartments/nc/durham/schedule-a-tour',
  },
]

export const showApplyNowButton = (line_id) => {
  return allowedLines.map((i) => i.id).includes(Number(line_id))
}

function ApplyNowButton() {
  const { line_id } = useContext(AppConfigContext)
  const { data } = useStore()

  function getLink(){
    if(data.property?.property_name.toLowerCase().indexOf("edmond") > -1 || data.property?.id === 3000085){
      return 'https://982b40be.app.doorloop.com/tenant-portal/rental-applications/listing?companyId=655e5d32a7b3680d91e19bdb&source=CompanyLink'
    }
    if(data.property?.property_name.toLowerCase().indexOf("oliver") > -1){
      return 'https://theoliverdallas.securecafe.com/onlineleasing/the-oliver10/oleapplication.aspx?stepname=floorplan&myOlePropertyId=1799634'
    }
    return allowedLines.find((l) => l.id === Number(line_id))?.link

  }

  return (
    <a
      href={getLink()}
      onClick={()=>{
        captureEvent(analyticsEvents.CTA_CONVERSION_BUTTON_TAPPED)
      }}
      target='_blank'
      className="bg-[#033A4D] rounded-[4px] text-white text-[14px] w-[158px] h-[32px] flex items-center justify-center" rel="noreferrer"
    >
      <ApplyNowIcon />
      <span className="font-semibold ml-[8px] leading-[0]">Apply Now</span>
    </a>
  )
}

export default ApplyNowButton
